import { motion } from "framer-motion";
import GlitchText from "./GlitchText";
import { ARENA_TUNNEL, ARENA_CARNIVAL, CITY_AERIAL } from "./assets";
import { useLang } from "./LanguageContext";

const ease = [0.22, 1, 0.36, 1];
const IMAGES = [ARENA_TUNNEL, ARENA_CARNIVAL, CITY_AERIAL];

export const Gallery = () => {
  const { t } = useLang();
  const labels = t("arenas.labels");
  return (
    <section id="media" data-testid="gallery-section" className="relative py-24 md:py-32 bg-[#080D1A] border-y border-[#00F2FE]/10 overflow-hidden">
      <div className="absolute inset-0 kumiko opacity-30" />
      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <p className="text-[#00F2FE] text-xs font-bold tracking-[0.3em] mb-4">{t("arenas.overline")}</p>
            <h2 className="font-display font-bold uppercase text-4xl sm:text-5xl lg:text-6xl leading-tight">
              {t("arenas.headingPre")} <GlitchText className="glitch-title text-[#00F2FE]">{t("arenas.headingGlitch")}</GlitchText>
            </h2>
          </div>
          <p className="font-mono-x text-xs text-slate-500 tracking-[0.2em] max-w-xs">{t("arenas.note")}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {IMAGES.map((url, i) => (
            <motion.div
              key={i}
              data-testid={`gallery-item-${i}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, ease, delay: i * 0.1 }}
              className="group relative aspect-[4/5] rounded-sm overflow-hidden border border-[#00F2FE]/20 hover:border-[#F9D423]/60 transition-all duration-500"
            >
              <img src={url} alt={labels[i]} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#060A14] via-transparent to-transparent" />
              <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 shadow-[inset_0_0_50px_rgba(0,242,254,0.28)]" />
              <p className="absolute top-4 left-4 font-mono-x text-[10px] tracking-[0.25em] text-[#F9D423]">ARENA 0{i + 1}</p>
              <p className="absolute bottom-4 left-4 font-display font-bold uppercase text-lg tracking-wide text-white">{labels[i]}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
